import { Component } from 'react';

interface Props {
  day: Date;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modifiers?: any;
}

class DefaultCalendarDay extends Component<Props> {
  render() {
    const { day } = this.props;

    return (
      <div className="Calendar-day">
        <div className="Calendar-dayContent">{day.getDate()}</div>
      </div>
    );
  }
}

export default DefaultCalendarDay;
